const POLICIES = [
  {
    title: "Privacy Notice",
    ver: "v2.4 · Approved · Mar 2026",
    text: "Customer-facing notice covering collection purposes, Data Principal rights and grievance redressal under the DPDP Act.",
    chips: ["DPDP §4–6", "Public", "EN / HI"],
  },
  {
    title: "Data Retention Policy",
    ver: "v1.8 · In review · Jul 2026",
    text: "Retention schedules mapped to ROPA purposes — including deletion triggers, archival rules and lawful exception handling.",
    chips: ["Retention", "Internal", "Linked to ROPA"],
  },
  {
    title: "Processor Agreement Addendum",
    ver: "v3.1 · Approved · Jun 2026",
    text: "Standard contractual clauses for personal data processors — obligations, breach notification and audit rights aligned to DPDP.",
    chips: ["TPRM", "Legal", "Template"],
  },
  {
    title: "Breach Response Playbook",
    ver: "v2.0 · Approved · Jan 2026",
    text: "Operational playbook for detection, triage, notification and post-incident review — ready to attach to live breach cases.",
    chips: ["Breach", "Security", "Playbook"],
  },
  {
    title: "Consent Management Policy",
    ver: "v1.5 · Draft · Jul 2026",
    text: "Rules for obtaining, recording, withdrawing and proving consent across digital and offline collection channels.",
    chips: ["Consent", "Draft", "AI draft"],
  },
  {
    title: "Cross-Border Transfer Policy",
    ver: "v1.2 · Approved · May 2026",
    text: "Transfer assessment criteria, restricted country handling and documentation standards for personal data leaving India.",
    chips: ["Transfers", "Legal", "Board approved"],
  },
];

function PolicyDoc({ title, ver, text, chips }) {
  return (
    <article className="rounded-[6px] bg-surface border border-line overflow-hidden transition-all hover:border-teal hover:-translate-y-[3px] hover:shadow-[0_12px_32px_rgba(7,17,31,0.08)]">
      <div className="relative bg-ink2 text-white p-[1.35rem_1.35rem_1.1rem]">
        <div className="inline-flex items-center gap-[0.35rem] text-[0.68rem] font-semibold tracking-[0.08em] uppercase text-[#FBBF24] mb-[0.6rem]">
          <i className="bi bi-stars text-[#FCD34D]" /> AI Generated
        </div>
        <h3 className="text-[1.05rem] font-bricolage font-semibold m-0 mb-[0.35rem]">
          {title}
        </h3>
        <div className="text-[0.8rem] text-white/45">{ver}</div>
        <span
          className="absolute bottom-0 left-0 right-0 h-[3px]"
          style={{ background: "linear-gradient(90deg, #0B8F7A, #12B89A)" }}
        />
      </div>
      <div className="p-[1.25rem_1.35rem_1.4rem]">
        <p className="text-[0.9rem] text-slate leading-[1.5] mb-4">{text}</p>
        <div className="flex flex-wrap gap-2">
          {chips.map((chip) => (
            <span
              key={chip}
              className="text-[0.72rem] font-semibold px-[0.55rem] py-1 rounded-[3px] bg-teal-soft text-teal"
            >
              {chip}
            </span>
          ))}
        </div>
        <div className="flex gap-[0.65rem] mt-[1.1rem]">
          <button
            type="button"
            className="flex-1 text-[0.78rem] font-semibold py-[0.4rem] rounded border border-teal bg-teal text-white hover:bg-teal-bright hover:border-teal-bright transition-colors"
          >
            Preview
          </button>
          <button
            type="button"
            className="flex-1 text-[0.78rem] font-semibold py-[0.4rem] rounded border border-line bg-white text-ink hover:border-teal hover:text-teal transition-colors"
          >
            Export
          </button>
        </div>
      </div>
    </article>
  );
}

export default function PolicyStore() {
  return (
    <section id="policies" className="py-[5.5rem] bg-white">
      <div className="container mx-auto max-w-[1140px] px-4">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          Policy Store
        </p>
        <h2 className="font-bricolage text-[clamp(1.85rem,3.2vw,2.45rem)] mb-3 text-ink">
          Policies drafted by AI. Tuned by your team.
        </h2>
        <p className="text-[1.08rem] leading-[1.65] text-slate max-w-[40rem]">
          AI drafts your compliance policies in minutes. Edit them in Word, or
          download a PDF — then map each document to the controls and
          obligations that keep your DPDP programme audit-ready.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12">
          {POLICIES.map((p) => (
            <PolicyDoc key={p.title} {...p} />
          ))}
        </div>

        <div className="mt-10 p-[1.5rem_1.75rem] bg-surface border-l-[3px] border-teal rounded-r-md">
          <p className="m-0 text-slate-2 text-[0.98rem] leading-[1.55]">
            <strong>How it works:</strong> AI drafts from your ROPA profile and
            sector templates → you edit in Word or download as PDF → approve and
            publish in the Policy Store → map each policy to Gap Assessment
            controls. One source of policy truth for compliance.
          </p>
        </div>
      </div>
    </section>
  );
}
